/* import __COLOCATED_TEMPLATE__ from './backdrop.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();